<script setup lang="ts">
const { reserveId } = defineProps<{
    reserveId: number;
}>();
const emit = defineEmits<{
    close: [arg: { message?: string; success?: boolean; canceled?: boolean }];
}>();
const autoReserveStore = useAutoReserveStore();
const { cancellationReasons } = storeToRefs(autoReserveStore);
const analyticsStore = useAnalyticsStore();
const description = ref('');
const isCanceled = ref(false);
const loading = ref(false);
const reasonItems = ref<Record<number, boolean>>({});

const disabled = computed(
    () =>
        Object.entries(reasonItems.value).filter(([, value]) => value)
            .length === 0
);

async function cancel() {
    isCanceled.value = true;
    loading.value = true;
    try {
        await autoReserveStore.cancelDemand({
            automaticReserveDemandId: reserveId,
            cancellationRequest: {
                description: description.value,
                reasons: Object.entries(reasonItems.value)
                    .filter(([, value]) => value)
                    .map(([key]) => +key),
            },
        });
        loading.value = false;
        emit('close', { message: '', success: true });
    } catch (error: any) {
        loading.value = false;
        reportException(error);
        emit('close', { success: false, message: error.message });
    }
}

onMounted(() => analyticsStore.trackPosthog('open-auto-reserve-cancel-modal'));

onUnmounted(() => {
    if (isCanceled.value) {
        analyticsStore.trackPosthog('auto-reserve-canceled');
    } else {
        analyticsStore.trackPosthog('cancel-canceling-auto-reserve');
    }
});
</script>
<template>
    <mr-modal
        title="حذف رزرو خودکار"
        mobile-page
        width="500px"
        @close="emit('close', { canceled: true })"
    >
        <div class="cancel-root">
            <mr-input-container
                size="free"
                label="دلیل حذف رزرو خودکار را انتخاب کنید."
                ghost
            >
                <div class="checkbox-container">
                    <mr-checkbox
                        v-for="reason in cancellationReasons"
                        :key="reason.id"
                        v-model="reasonItems[reason.id || 0]"
                        :label="reason.title || ''"
                    />
                </div>
            </mr-input-container>
            <mr-input
                v-model="description"
                text-area
                full-width
                label="لطفاً در صورت تمایل سایر دلایل خود را ذکر کنید:"
            />
        </div>
        <template #footer>
            <div class="actions">
                <mr-button
                    full-width
                    variant="bordered"
                    @click="emit('close', { canceled: true })"
                >
                    انصراف
                </mr-button>
                <mr-button :disabled full-width :loading @click="cancel">
                    تأیید و لغو
                </mr-button>
            </div>
        </template>
    </mr-modal>
</template>

<style lang="scss" scoped>
.checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.actions {
    display: flex;
    align-items: center;
    gap: 16px;
}
</style>
